module.exports = __webpack_public_path__ + "static/media/b-sci-major-29_LR.0fdb9a38.jpg";